import type { AgentSdk, VoiceTask } from "@/sdk";
import { clearCallbackState, TASK_WRAPUP_REASON } from "@/sdk";
import { useCallbacksFormStore } from "./ScheduleCallback/callbacksForm.store";

//TODO: Consider moving this logic

/** interacts with the agentSdk to end the given task/end the call */
export const handleEndCall = async (agentSdk: AgentSdk, task: VoiceTask) => {
    if (task.status === "pending") {
        await agentSdk.wrapupTask(task, TASK_WRAPUP_REASON);
    } else if (task.status === "assigned") {
        await agentSdk.hangupCall(task, TASK_WRAPUP_REASON);
    } else {
        throw new Error("Cannot hangup a call associated with a task not in pending or assigned status.");
    }
};

/** Clears the customer callback state when a call is completed */
export function clearCallbacksState() {
    clearCallbackState();
    useCallbacksFormStore.getState().setCallbackScheduled(false);
}
